import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ConfigService } from 'app/core/services/config.service';
import { RequestService } from 'app/core/services/request.service';

@Injectable()
export class CreditService {

	constructor(
		private configService: ConfigService,
		private requestService: RequestService
	) { }
	
	getCreditDetails(id: string): Observable<any> {
		let url = this.configService.get('server').url + this.configService.get('endpoints').agora.credit.details.api + '/' + id;
		return this.requestService.get(url)
	}

	getDecisionDto() {
		let url = this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.decisionCredit.api;
		return this.requestService.get(url)
	}

	rejectCreditApplication(details: any):Observable<any> {
		let url = this.configService.get('server').url + this.configService.get('endpoints').agora.credit.reject.api;
		return this.requestService.post(url, details)
	}

	approveCreditApplication(details: any):Observable<any> {
		let url = this.configService.get('server').url + this.configService.get('endpoints').agora.credit.approve.api;
		return this.requestService.post(url, details)
	}

	getDetailsFields() {
		let fields = [
			{
				key: 'buyerId',
				label: 'Buyer ID',
				type: 'text'
			},
			{
				key: 'buyerName',
				label: 'Buyer Name',
				type: 'text'
			},
			{
				key: 'userName',
				label: 'User Name',
				type: 'text'
			},
			{
				key: 'userEmail',
				label: 'User Email',
				type: 'text'
			},
			{
				key: 'currentCreditLimitAmount',
				label: 'Current Credit Limit Amount',
				type: 'text'
			},
			{
				key: 'currentedCreditLimitCurrency',
				label: 'Current Credit Limit Currency',
				type: 'text'
			},
			{
				key: 'requestedCreditLimitAmount',
				label: 'Requested Credit Limit Amount',
				type: 'text'
			},
			{
				key: 'requestedCreditLimitCurrency',
				label: 'Requested Credit Limit Currency',
				type: 'text'
			},
			{
				key: 'paymentTerm.configValue',
				label: 'Requested Payment Term',
				type: 'text'
			},
			{
				key: 'products',
				label: 'Products or product categories expected to order',
				type: 'text'
			},
			{
				key: 'estimatedPurchase',
				label: 'Estimated Purchase (on average per month) in the coming 12 months',
				type: 'text'
			},
			{
				key: 'rating',
				label: 'Does company have a rating from Dun & Bradstreet or another agency?',
				type: 'map',
				map: {
					true: 'Yes',
					false: 'No'
				}
			},
			{
				key: 'ratingAgency',
				label: 'Rating and Rating Agency',
				type: 'text'
			},
			{
				key: 'ratingFile',
				label: 'Rating File',
				type: 'link',
                config : {
                    placeholder: 'Download rating'
                }
			},
			{
				key: 'annualRevenue',
				label: 'Annual Revenue',
                type: 'text'
			},
			{
				key: 'balanceSheet',
				label: 'P&L and Balance Sheet for the past full year',
                type: 'link',
                config : {
                    placeholder: 'Download file'
                }
			},
			{
				key: 'accountAudited',
				label: 'Are annual accounts audited by an auditor?',
				type: 'map',
                map: {
					true: 'Yes',
					false: 'No'
				}
			},
			{
				key: 'auditorWebsite',
				label: 'Auditor Website',
				type: 'link',
				config: {
					placeholder: 'auditorWebsite'
				}
			},
			{
				key: 'additionalInfo',
				label: 'Additional Info',
                type: 'textarea'
			},
			{
				key: 'contactPerson',
				label: 'Contact Person',
                type: 'text'
			},
			{
				key: 'status.configValue',
				label: 'Status',
                type: 'text'
			},
			{
				key: 'creditDecision.decision.configValue',
				label: 'Decision',
                type: 'text'
			}

		];
		return fields;
	}

}



// WEBPACK FOOTER //
// ./src/app/agora/components/account-data/credit/credit.service.ts